import INVENTORY_API_BASE_URL from "../../config/api";
import  { useState, useEffect } from "react";
import "./managescan.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";

function Managescan() {
  const [data, setData] = useState([]);
  const [dataa, setDataa] = useState([]);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getApproveDPO`).then((response) => {
      setData(response.data); 
    });
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getship`).then((response) => {
      const latest30Data = response.data;
      setDataa(latest30Data);
    });
  }, []);

  const filteredData = data.filter((row) => {
    return (
      row.dispatchthrough === "Shivalik Enterprises" &&
      dataa.some((shipment) => {
        return (
          shipment.barcodeData?.[0]?.OrderNum === row.shipmentid ||
          shipment.barcodeData?.[0]?.OrderNum === row.Dorderid
        );
      })
    );
  });

  return (
    <div>
      <h6 className="managescandata">
        <h5>Manage Scan Data</h5>
      </h6>
      <br />
      <br />

      <div className="managescancontainer">
            <div className="managescancontent">
      <Table className="managescandatashi">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Distributor Name</th>
            <th>Dispatch Through</th>
            <th>SKU</th>
            <th>Title</th>
            <th>Medium</th>
            <th>Edition</th>
            <th>Scan Data</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((row, index) => (
            <tr key={index}>
              <td>{row.shipmentid}</td>
              <td>{row.distributorName}</td>
              <td>{row.dispatchthrough}</td>
              <td>
                {row.updatedQuantity.map((quantityData, idx) => (
                  <div key={idx}>
                    <td>{quantityData.sku}</td>
                    <td>{quantityData.userDefinedSKU}</td>
                  </div>
                ))}
              </td>

              <td>
                {row.updatedQuantity.map((quantityData, idx) => (
                  <div key={idx}>
                    <td>{quantityData.title}</td>
                    <td>{quantityData.userDefinedtitle}</td>
                  </div>
                ))}
              </td>

              <td>
                {row.updatedQuantity.map((quantityData, idx) => (
                  <div key={idx}>
                    <td>{quantityData.Medium}</td>
                    <td>{quantityData.userDefinedMedium}</td>
                  </div>
                ))}
              </td>

              <td>
                {row.updatedQuantity.map((quantityData, idx) => (
                  <div key={idx}>
                    <td>{quantityData.edition}</td>
                    <td>{quantityData.userDefinededition}</td>
                  </div>
                ))}
              </td>

              <td>
                {dataa.map((shipment) =>
                  shipment.barcodeData.map((barcode, index) => {
                    if (
                      barcode.OrderNum === row.shipmentid ||
                      barcode.OrderNum === row.Dorderid
                    ) {
                      return (
                        <tr key={index}>
                          <td>{barcode.count}</td>
                        </tr>
                      );
                    } else {
                      return null;
                    }
                  })
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      </div>
      </div>
    </div>
  );
}

export default Managescan;
